module.exports = "https://tutorchat.chegg.com/static/media/ic-shape-rectangle.c7b754b0.svg";